import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import searcher from "../../../assets/searchInput.svg";
import { useDispatch } from "react-redux";
import TableContainer from "../../layouts/table-container/table-container";
import { productBulkVerify } from "../../../redux/actions/divisionAction";
import ErrorPopup from "../../popups/ErrorPopup";
import ChangeSaved from "../../popups/ChangeSaved";
import CloseIcon from "../../../assets/icons/closeIcon";
import "../bulk-upload/bulk-upload.css";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import Select from "react-select";
import {
  reportingFFList,
  subordinatesList,
  updateSubordinatesRM,
} from "../../../redux/actions/fieldForceAction";
import { useParams } from "react-router-dom";
import LoadingSpinnerTable from "../../utilites/loader";

const SubordinatesTaleModal = ({ show, ShowClose, reportingManager }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [fieldForceList, setFieldForceList] = useState([]);
  const [filteredFieldForceList, setfilteredFieldForceList] = useState([]);
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [reassignActive, setReassignActive] = useState(false);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (show) {
      setloading(true);
      dispatch(subordinatesList({ user_id: params.id }, onSuccess, onError));
    }
  }, [show]);

  console.log(productVerifiedList, "productVerifiedList");

  const onSuccess = (data) => {
    setFieldForceList(data.data.data.subordinates);
    setfilteredFieldForceList(data.data.data.subordinates);
    setloading(false);
  };
  const onError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
    setloading(false);
  };

  const checkedProduct = (e, item) => {
    const { checked } = e.target;

    setProductVerifiedList((prevList) => {
      if (checked) {
        return [
          ...prevList,
          {
            ff_user_id: item.id,
            reporting_manger_id: "",
          },
        ];
      } else {
        return prevList.filter((obj) => obj.ff_user_id !== item.id);
      }
    });
  };

  const searchHandler = (e) => {
    console.log(e.target.value == "");

    if (e.target.value === "") {
      setfilteredFieldForceList(fieldForceList);
    } else {
      let newArr = fieldForceList.filter(
        (fieldForce) =>
          fieldForce.name
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          fieldForce.code.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setfilteredFieldForceList(newArr);
    }
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const handleOfferChange = (selectedOption, item) => {
    setProductVerifiedList((prevList) =>
      prevList.map((obj) =>
        obj.ff_user_id === item.id
          ? { ...obj, reporting_manger_id: selectedOption.value }
          : obj
      )
    );
  };

  const updateReportingManagerSubmit = () => {
    dispatch(
      updateSubordinatesRM(
        { ffUsers: productVerifiedList },
        onReportingManagerSuccess,
        onReportingManagerError
      )
    );
  };

  const onReportingManagerSuccess = (data) => {
    ShowClose();
    setReassignActive(false);
    setShowSuccessPopup(true);
    setProductVerifiedList([]);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const onReportingManagerError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="subordinate-data-table-container col-12 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <span className="fn_Nunito fw_700 fs_22">
              Subordinates {reassignActive ? "- Reassign" : ""}
            </span>
            <button
              className="border-0 bg-white"
              onClick={() => {
                ShowClose();
                setReassignActive(false);
                setProductVerifiedList([]);
              }}
            >
              <CloseIcon fill="black" width={"14px"} />
            </button>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container">
            <div className="search-container d-flex justify-content-between ">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search Field Force here by Field Force Name and Code..."
                  onChange={searchHandler}
                />
              </div>
            </div>
            <div style={{ height: "60vh", overflow: "auto" }}>
              <TableContainer>
                <thead>
                  <tr className="table-rows color_747f9e">
                    {reassignActive && (
                      <th className="table-heads " width={"1%"}></th>
                    )}
                    <th className="table-heads " width={"3%"}>
                      User ID
                    </th>
                    <th className="table-heads " width={"6%"}>
                      Field Force Name
                    </th>
                    <th className="table-heads " width={"5%"}>
                      Company ID
                    </th>
                    <th className="table-heads " width={"5%"}>
                      Designation
                    </th>
                    <th className="table-heads " width={"12%"}>
                      Head Quater
                    </th>
                    <th className="table-heads " width={"12%"}>
                      Division
                    </th>
                    <th className="table-heads " width={"6%"}>
                      status
                    </th>
                    {reassignActive && productVerifiedList.length > 0 && (
                      <th className="table-heads" width={"15%"}>
                        Assign To
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody style={{ position: "relative" }}>
                  {loading === true ? (
                    <div className="list-spinner-container">
                      <LoadingSpinnerTable />
                    </div>
                  ) : (
                    <>
                      {filteredFieldForceList && (
                        <>
                          {filteredFieldForceList?.map((item, index) => (
                            <tr className="table-rows1" key={index}>
                              {reassignActive && (
                                <td
                                  className="table-each-row-data"
                                  width={"3%"}
                                >
                                  <input
                                    type="checkbox"
                                    className="superCheck"
                                    id={`checkbox-${index}`}
                                    name="prodcutsCheck"
                                    onChange={(e) => checkedProduct(e, item)} // Pass individual item
                                    checked={productVerifiedList.some(
                                      (obj) => obj.ff_user_id === item.id
                                    )}
                                  />
                                </td>
                              )}
                              <td className="table-each-row-data">
                                {item.code}
                              </td>
                              <td className="table-each-row-data">
                                {item.name}
                              </td>
                              <td className="table-each-row-data">
                                {item.employee_id}
                              </td>
                              <td className="table-each-row-data">
                                {item.fieldForceDesignation.name}
                              </td>

                              <td
                                style={{ maxWidth: "450px" }}
                                className="table-each-row-data text-wrap"
                              >
                                {item.headQuaters?.length > 0
                                  ? item.headQuaters?.map((ele, index) => {
                                      return (
                                        <span
                                          style={{ whiteSpace: "pre-wrap" }}
                                          key={index}
                                        >
                                          <span style={{ color: "#B0B3C7" }}>
                                            {index ? " | " : ""}
                                          </span>
                                          {ele?.headQuater?.name
                                            ? ele?.headQuater?.name
                                            : "--"}
                                        </span>
                                      );
                                    })
                                  : "--"}
                              </td>
                              <td className="table-each-row-data">
                                {item.divisions?.length > 0
                                  ? item.divisions?.map((ele, index) => {
                                      return (
                                        <span
                                          style={{ whiteSpace: "pre-wrap" }}
                                          key={index}
                                        >
                                          <span style={{ color: "#B0B3C7" }}>
                                            {index ? " | " : ""}
                                          </span>
                                          {ele?.vendorDivision?.name
                                            ? ele?.vendorDivision?.name
                                            : "--"}
                                        </span>
                                      );
                                    })
                                  : "--"}
                              </td>
                              <td className="table-each-row-data">Active</td>

                              {reassignActive &&
                                productVerifiedList.some(
                                  (obj) => obj.ff_user_id === item.id
                                ) && (
                                  <td className="table-each-row-data">
                                    <div className="w-100 pe-2">
                                      <Select
                                        options={reportingManager}
                                        styles={customStyles}
                                        placeholder="Select the option"
                                        onChange={(selectedOption) =>
                                          handleOfferChange(
                                            selectedOption,
                                            item
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </tbody>
              </TableContainer>
            </div>
          </div>
          <div className="my-2 mt-4">
            {!reassignActive ? (
              <AdminButton
                background="#7065E4"
                color="white"
                width="180px"
                onClick={() => setReassignActive(true)}
              >
                <span className="m-2 fw_700">REASSIGN</span>
              </AdminButton>
            ) : (
              <div className="d-flex gap-4 justify-content-end">
                <AdminButton
                  background="#FF6F5B"
                  color="white"
                  width="180px"
                  onClick={() => setReassignActive(false)}
                >
                  <span className="m-2">CANCEL</span>
                </AdminButton>
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="180px"
                  onClick={updateReportingManagerSubmit}
                >
                  <span className="m-2 fw_700">CONFIRM</span>
                </AdminButton>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default SubordinatesTaleModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
